import React from 'react';
import LogoPc from './images/logo-pc.svg';
import LogoSp from './images/logo-sp.svg';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../states/GlobalStatesV3';
import { ClickableProps, StylableProps } from '../../../types/props';

export const BeautyLogo = observer(({ className, onClick }: StylableProps & ClickableProps) => {
  const pc = GlobalStatesV3.viewport.isNonSp;
  return <img id="beauty-logo" className={className} src={pc ? LogoPc : LogoSp} onClick={onClick} />;
});
